export enum EInboundBufferTab {
	ACTIVE = 'active',
	HISTORY = 'history',
}

export enum EStorageUnitLabelPrintStatus {
	PRINTED = 'printed',
	WAITING_FOR_PRINT = 'waiting_for_print',
}

export const LABEL_PRINT_ACCEPTED_STATUS = 'accepted'

export enum EInboundBufferItemStatus {
	WAITING_FOR_STORAGE = 'waiting_for_storage',
	STORAGE_UNITS_CREATED = 'storage_units_created',
	FULLY_LABELED = 'fully_labeled',
	RECEIVED_IN_WAREHOUSE = 'received_in_warehouse',
}

// Domyślnie 50 (EXTENDED_PAGE_SIZE), dwa stopnie w dół i dwa w górę.
// Backend waliduje page[size] max:200 - musi być wdrożony przed frontem.
// eslint-disable-next-line no-magic-numbers
export const INBOUND_BUFFER_PER_PAGE_OPTIONS = [10, 25, 50, 100, 200]

export const HISTORY_INBOUND_BUFFER_STATUSES = [EInboundBufferItemStatus.RECEIVED_IN_WAREHOUSE]

export const ACTIVE_INBOUND_BUFFER_STATUSES = [
	EInboundBufferItemStatus.WAITING_FOR_STORAGE,
	EInboundBufferItemStatus.STORAGE_UNITS_CREATED,
	EInboundBufferItemStatus.FULLY_LABELED,
]

export const INBOUND_BUFFER_SSE_EVENTS = {
	BUFFER_ITEM_CREATED: 'wms.inbound.buffer-item-created.v1',
	BUFFER_ITEM_STORAGE_UNITS_CREATED: 'wms.inbound.buffer-item-storage-units-created.v1',
	BUFFER_ITEM_RESET_TO_INITIAL_STATE: 'wms.inbound.buffer-item-reset-to-initial-state.v1',
	LABEL_PREVIEW_READY: 'labeling.storage-unit-label-preview.ready-for-display.v1',
	LABEL_READY_FOR_DOWNLOAD: 'labeling.storage-unit-label.ready-for-download.v1',
} as const
